// GlobalStateProvider.js
import React, { useState } from "react";
import { GlobalStateContext } from "./globalContext";
export const GlobalStateProvider = ({ children }) => {
    const [addObj, setAddObj] = useState({
        address: "",
        latitude: "",
        longitude: ""
    });

    return (
        <GlobalStateContext.Provider value={{ addObj, setAddObj }}>
            {children}
        </GlobalStateContext.Provider>
    );
};